<template>
  <div class="w-100 space-for-navbar mb-3">
    <div
      id="SplashContainer"
      class="m-0 p-0 centered-on-page"
    >
      <div class="m-0 p-0 w-100 h-100">
        <svg
          class="m-0 p-0"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1000 560"
        >
          <title>Contact Us</title>
          <g id="Splashes">
            <g id="Contact">
              <image
                width="7360"
                height="4140"
                transform="translate(0.14 0.19) scale(0.14)"
                :xlink:href="require('../assets/purchased_pics/rawpixel-597770.jpg')"
              />
              <g
                id="TeamLabel-2"
                data-name="TeamLabel"
              >
                <text
                  class="bmg-splashes-15"
                  transform="translate(401.82 149.12)"
                ><tspan class="bmg-splashes-31">C</tspan><tspan
                  x="27.84"
                  y="0"
                >ont</tspan><tspan
                  class="bmg-splashes-27"
                  x="96.24"
                  y="0"
                >a</tspan><tspan
                  class="bmg-splashes-32"
                  x="119.92"
                  y="0"
                >c</tspan><tspan
                  class="bmg-splashes-21"
                  x="142.68"
                  y="0"
                >t Us</tspan></text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(281.98 178.71)"
                ><tspan class="bmg-splashes-24">t</tspan><tspan
                  x="9.67"
                  y="0"
                >o Dis</tspan><tspan
                  class="bmg-splashes-33"
                  x="71.5"
                  y="0"
                >c</tspan><tspan
                  class="bmg-splashes-7"
                  x="85.35"
                  y="0"
                >ov</tspan><tspan
                  x="113.82"
                  y="0"
                >er t</tspan><tspan
                  class="bmg-splashes-6"
                  x="155.65"
                  y="0"
                >h</tspan><tspan
                  x="172.62"
                  y="0"
                >e </tspan><tspan
                  class="bmg-splashes-28"
                  x="194.27"
                  y="0"
                >W</tspan><tspan
                  class="bmg-splashes-7"
                  x="220.67"
                  y="0"
                >e</tspan><tspan
                  x="235.4"
                  y="0"
                >a</tspan><tspan
                  class="bmg-splashes-26"
                  x="250.15"
                  y="0"
                >l</tspan><tspan
                  x="256.92"
                  y="0"
                >th of </tspan><tspan
                  class="bmg-splashes-34"
                  x="321.25"
                  y="0"
                >P</tspan><tspan
                  x="338.87"
                  y="0"
                >ossiblities</tspan></text>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="container-fluid bg-dark w-xs-90 w-lg-80 p-5">
      <div class="h1 text-white text-center mb-4">
        Contact Bridging Medical
      </div>
      <div class="row h4">
        <div class="col-md-6 w-90 mb-4">
          <BioCard
            name="Robert Patty, PH.D, MBA, PE"
            title="BMG President &amp; CEO"
            pic="bmg-bio-pic-robert-patty bmg-contact-bio-pic"
            email="Robert.Patty@BridgingMedical.com"
            phone="+1 (325) 261-2874"
            location="Indiana (EST)"
            :show-bio="false"
            :selected="true"
            calendly="robert-patty"
          />
        </div>
        <div class="col-md-6 w-90 mb-4">
          <BioCard
            name="Christian Haller"
            title="Chairman of BMG Advisory Board"
            pic="bmg-bio-pic-haller bmg-contact-bio-pic"
            email="Christian.Haller@BridgingMedical.com"
            phone="+1 (703) 629-2449"
            location="Virginia"
            :show-bio="false"
            :selected="true"
            calendly="christian-haller"
          />
        </div>
      </div>
      <div class="row h4">
        <div class="col-md-6 w-90 mb-4">
          <BioCard
            name="Richard Belnap"
            title="BMG VP Marketing and Sales"
            pic="bmg-bio-pic-richard-belnap bmg-contact-bio-pic"
            email="Richard.Belnap@BridgingMedical.com"
            phone="+1 (801) 380-2376"
            location="Utah (MDT)"
            :show-bio="false"
            :selected="true"
            calendly="richard-belnap"
          />
        </div>
        <div class="col-md-6 w-90 mb-4">
          <BioCard
            name="Cameron Field, DPM"
            title="BMG Chief Medical Officer"
            pic="bmg-bio-pic-field bmg-contact-bio-pic"
            email="Cameron.Field@BridgingMedical.com"
            location="Colorado (MDT)"
            :show-bio="false"
            :selected="true"
          />
        </div>
        <!-- <div class="col-lg-3 w-90 mb-4 p-2">
          <div class="card rounded w-100 bg-white p-4 centered-on-page">
            <img class="w-90" src="../assets/logos/RedcrowLogo.jpg">
            <p class="text-dark mt-3">
              Bridging Medical Group is using the RedCrow INVEST platform to track and manage investments in our company. We encourage you to visit the website to find out more about how to invest with BMG. Thanks!
            </p>
            <div class="my-3">
              <a class="bmg-btn-white-outline externalLinksGoogleTracking" href="https://www.redcrow.com/home/discover-profile.html?id=1000048352049" target="_blank"><span >Learn More about Investing in BMG on RedCrow's Platform</span></a>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!--Section: Contact v.2-->
    <!-- <section class="container-fluid my-4 w-xs-90 w-lg-50">
        <h2 class="h1 font-weight-bold text-center my-4">Contact Bridging Medical Group, LLC</h2>
        <p class="text-center w-responsive mx-auto mb-5">Do you have any questions? Please do not hesitate to contact us directly using the contact info above, or by submitting this form. You may anticipate a quick response.</p>
        <div class="mb-md-0 mb-5">
          <div>
            <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
              <label class="form__label">Name</label>
              <input class="form__input" v-model.trim="$v.name.$model"/>
            </div>
            <div class="error" v-if="!$v.name.required">Field is required</div>
            <div class="error" v-if="!$v.name.minLength">Name must have at least {{$v.name.$params.minLength.min}} letters.</div>
            <tree-view :data="$v.name" :options="{rootObjectKey: '$v.name', maxDepth: 2}"></tree-view>
            <div class="form-group" :class="{ 'form-group--error': $v.age.$error }">
              <label class="form__label">Age</label>
              <input class="form__input" v-model.trim.lazy="$v.age.$model"/>
            </div>
            <div class="error" v-if="!$v.age.between">Must be between {{$v.age.$params.between.min}} and {{$v.age.$params.between.max}}</div><span tabindex="0">Blur to see changes</span>
            <tree-view :data="$v.age" :options="{rootObjectKey: '$v.age', maxDepth: 2}"></tree-view>
          </div>
          <form id="contact-form" name="contact-form" action="" method="POST" @submit="checkForm">
            <div class="row">
              <div class="col-md-6">
                <div class="md-form mb-0">
                  <input type="text" id="name" name="name" v-model.trim="name" class="form-control" required>
                  <label for="name" class="">Your name</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="md-form mb-0">
                  <input type="text" id="email" name="email" v-model.trim="email" class="form-control" required>
                  <label for="email" class="">Your email</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="md-form mb-0">
                  <input type="tel" id="phone" name="phone" v-model.trim="phone" class="form-control" required>
                  <label for="phone" class="">Your Phone</label>
                </div>
              </div>
              <div class="col-md-4">
                <div class="md-form mb-0">
                  <input type="number" id="timezone" name="timezone" v-model.trim="timezone" class="form-control">
                  <label for="timezone" class="">Your Time Zone</label>
                </div>
              </div>
              <div class="col-md-4">
                <div class="h4">
                  What is your preferred contact method?
                </div>
                <div class="form-check mb-3">
                    <input class="form-check-input" type="radio" id="preferredContactMethod" name="preferredContactMethodPhone" v-model.trim="preferredContactMethodPhone" value="phone" checked>
                    <label class="form-check-label" for="preferredContactMethodPhone">Phone</label>
                </div>
                <div class="form-check mb-3">
                    <input class="form-check-input" type="radio" id="preferredContactMethod" name="preferredContactMethodEmail" v-model.trim="preferredContactMethodEmail" value="email">
                    <label class="form-check-label" for="preferredContactMethodEmail">Email</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="md-form mb-0">
                  <input type="text" id="subject" name="subject" v-model.trim="subject" class="form-control">
                  <label for="subject" class="">Subject</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="md-form">
                  <textarea type="text" id="message" name="message" v-model.trim="message" rows="10" class="form-control md-textarea"></textarea>
                  <label for="message">Your message...</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                Please verify you are a human...
                <div class="md-form">
                  <input type="number" id="antiSpam" name="antiSpam" v-model.trim="antiSpam" class="form-control">
                  <label for="antiSpam" class="">What is the number after 5?</label>
                </div>
              </div>
            </div>
          </form>
          <div class="text-center text-md-left">
            <a class="btn btn-primary" onclick="document.getElementById('contact-form').submit();">Send</a>
          </div>
          <div class="status"></div>
        </div>
    </section> -->
  </div>
</template>

<script>
import SecurityCheckMixin from './mixins/SecurityCheckMixin'
import BioCard from './BioCard'
// import { required, minLength, between, email, numeric, helpers } from 'vuelidate/lib/validators'

export default {
  mixins: [SecurityCheckMixin],
  name: 'Contact',
  data: function () {
    return {
      name: null,
      email: null,
      subject: null,
      message: null,
      antiSpam: null,
      phone: null,
      timezone: null,
      preferredContactMethodPhone: null,
      preferredContactMethodEmail: null,
      preferredContactMethod: null
    }
  },
  // validations: {
  //   name: {
  //     required,
  //     minLength: minLength(2)
  //   },
  //   email: {
  //     required
  //   }
  // },
  components: {
    BioCard
  },
  methods: {
    checkForm () {
    },
    scrollToSection (section) {
      // console.log('Attempting to scroll to ' + section + ' section...')
      if (section) {
        var desiredSection = document.getElementById(section)
        // console.log('Section = ')
        // console.log(desiredSection)
        if (desiredSection) {
          desiredSection.scrollIntoView()
        }
      }
    }
  },
  beforeMount () {},
  mounted () {
    // console.log('Section = ' + this.$route.params.section)
    this.scrollToSection(this.$route.params.section)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
